import { injectIntl } from "react-intl"


export const VACCIN = 1
export const MEDICAMENT = 2



export const TYPE_TRAITEMENT = {
    [VACCIN]:  "VACCINATION.VACCIN",
    [MEDICAMENT]:  "VACCINATION.MEDICAMENT",
}
  
export const typeTraitementUIHelper = (intl) => 
  Object.keys(TYPE_TRAITEMENT).map((value) => ({
    value : Number(value),
    label: intl.formatMessage({ id: TYPE_TRAITEMENT[value] }),
  
}))


